import React, { useState } from 'react';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import Icon, {
  PictureOutlined,
  TeamOutlined,
  ShopOutlined,
  DollarOutlined,
  FileTextOutlined,
  ExperimentOutlined,
  StockOutlined,
  ProductOutlined,
  HeatMapOutlined
} from '@ant-design/icons';
import type { GetProps } from 'antd';
// Extend the MenuItem type to include an optional envRestriction property
type RestrictedMenuItem = Required<MenuProps>['items'][number] & {
  envRestriction?: 'test' | 'production' | 'development';
};

type CustomIconComponentProps = GetProps<typeof Icon>;

type MenuItem = Required<MenuProps>['items'][number];
const FarmerSvg: React.FC = () => (
  <svg fill="#000000" width="1.5em" height="1.5em" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 470 470" xmlSpace="preserve" >
    <g>
      <path d="M403.204,336.001c-0.46-0.485-0.984-0.907-1.558-1.256c-12.934-10.356-27.465-18.792-43.163-24.872
		c-0.406-0.199-0.832-0.363-1.276-0.486c-16.135-6.094-33.475-9.705-51.556-10.369c-1.362-1.89-3.576-3.125-6.083-3.125
		s-4.722,1.235-6.083,3.125c-18.082,0.665-35.422,4.275-51.556,10.369c-0.445,0.124-0.872,0.288-1.279,0.487
		c-15.697,6.081-30.228,14.516-43.161,24.871c-0.575,0.349-1.099,0.771-1.56,1.257c-36.586,30.029-59.967,75.583-59.967,126.498
		c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5c0-40.628,16.395-77.495,42.908-104.348v102.727c0,0.557,0.065,1.099,0.18,1.621
		c0.741,3.362,3.734,5.879,7.32,5.879s6.578-2.517,7.32-5.879c0.115-0.522,0.18-1.064,0.18-1.621V344.867
		c8.509-6.575,17.746-12.249,27.57-16.878v63.088c0,4.143,3.357,7.5,7.5,7.5h111.255c4.143,0,7.5-3.357,7.5-7.5v-63.088
		c9.824,4.629,19.062,10.302,27.57,16.878v116.012c0,0.557,0.065,1.099,0.18,1.621c0.741,3.362,3.734,5.879,7.32,5.879
		s6.578-2.517,7.32-5.879c0.115-0.522,0.18-1.064,0.18-1.621V358.151c26.514,26.853,42.908,63.72,42.908,104.349
		c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5C463.172,411.585,439.79,366.031,403.204,336.001z M251.438,383.577v-61.68
		c12.845-4.409,26.478-7.108,40.628-7.815v19.313c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-19.313
		c14.149,0.707,27.782,3.406,40.627,7.814v61.681H251.438z"/>
      <path d="M157.678,143.304V7.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v128.304h-30.283V7.5c0-4.143-3.357-7.5-7.5-7.5
		s-7.5,3.357-7.5,7.5v128.304H67.111V7.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v128.304H21.828V7.5
		c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v135.804c0,21.384,17.396,38.78,38.78,38.78h29.145V462.5c0,4.143,3.357,7.5,7.5,7.5
		s7.5-3.357,7.5-7.5V182.084h29.145C140.281,182.084,157.678,164.688,157.678,143.304z M23.047,150.804h118.412
		c-3.149,9.447-12.07,16.28-22.561,16.28H45.608C35.117,167.084,26.196,160.251,23.047,150.804z"/>
      <path d="M180.893,182.084h33.527c-0.265,2.752-0.407,5.521-0.407,8.291c0,47.175,38.379,85.554,85.554,85.554
		c47.174,0,85.553-38.379,85.553-85.554c0-2.77-0.143-5.539-0.408-8.291h33.248c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5
		h-36.028l-17.409-72.345c-1.72-7.146-6.124-13.07-12.4-16.68c-6.278-3.609-13.61-4.437-20.655-2.328l-31.107,9.313l-31.106-9.313
		c-7.021-2.104-14.37-1.294-20.691,2.278c-6.322,3.571-10.808,9.446-12.631,16.545l-18.632,72.529h-36.405
		c-4.143,0-7.5,3.357-7.5,7.5S176.75,182.084,180.893,182.084z M255.938,91.069c2.734-1.545,5.934-1.89,9.011-0.969l33.258,9.958
		c1.404,0.42,2.898,0.42,4.303,0l33.259-9.958c3.055-0.914,6.207-0.572,8.874,0.962c2.669,1.535,4.549,4.087,5.295,7.187
		l16.565,68.835H232.784l17.673-68.797C251.256,95.178,253.202,92.615,255.938,91.069z M370.119,190.375
		c0,38.903-31.649,70.554-70.553,70.554s-70.554-31.65-70.554-70.554c0-2.776,0.181-5.545,0.502-8.291h140.103
		C369.938,184.831,370.119,187.601,370.119,190.375z"/>
      <path d="M355.19,413.58h-61.25c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h61.25c4.143,0,7.5-3.357,7.5-7.5
		S359.333,413.58,355.19,413.58z"/>
      <path d="M263.94,413.58h-20c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h20c4.143,0,7.5-3.357,7.5-7.5
		S268.083,413.58,263.94,413.58z"/>
    </g>
  </svg >
)

const LandSvg: React.FC = () => (
  <svg fill="#000000" height="1.5em" width="1.5em" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24" xmlSpace="preserve">
    <g id="map-location">
      <path className="st0" d="M18.3,4.4C17.4,1.8,14.9,0,12,0C8.8,0,6.1,2.3,5.4,5.3L0,3v17.2l8,3.4l8-3l8,3.4V6.8L18.3,4.4z M9,14.4
		c1.2,1.4,2.3,2.2,2.4,2.3l0.7,0.6l0.6-0.6c0.3-0.3,0.7-0.7,1.1-1c0.4-0.4,0.8-0.8,1.2-1.2v4.3l-6,2.3V14.4z M12,2
		c2.6,0,4.8,2.1,4.8,4.8c0,1.9-0.8,3.4-1.8,4.7l0,0l0,0c-0.8,1-1.7,1.9-2.6,2.7c-0.1,0.1-0.3,0.3-0.4,0.4c-1.8-1.6-4.8-5-4.8-7.8
		C7.2,4.1,9.4,2,12,2z M2,6l3.3,1.4c0.2,1.5,0.9,3,1.7,4.4V21l-5-2.1V6z M22,21l-5-2.1v-6.7c1-1.5,1.8-3.2,1.8-5.4L22,8.2V21z"/>
      <circle className="st0" cx="12" cy="7" r="2" />
    </g>
  </svg>
)

const FarmSvg: React.FC = () => (
  <svg fill="#000000" height="1.5em" width="1.5em" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 511.573 511.573" xmlSpace="preserve">
    <g transform="translate(1 1)">
      <g>
        <g>
          <path d="M492.28,250.307l-32.442-64.885c-0.042-0.948-0.234-1.592-1.088-2.176l-0.603-1.206c-0.32-0.639-0.759-1.218-1.29-1.727
				l-49.91-99.82c-0.853-1.707-1.707-2.56-3.413-3.413L258.467,0.28c-2.56-1.707-5.12-1.707-7.68,0L105.72,77.08
				c-1.707,0.853-2.56,1.707-3.413,3.413l-51.2,102.4c-0.853,0.853-0.853,1.707-0.853,3.413L17.827,251.16
				c-2.56,4.267-0.853,9.387,3.413,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-4.267L50.253,223v279.04
				c0,5.12,3.413,8.533,8.533,8.533h93.867h102.4h102.4h93.867c5.12,0,8.533-3.413,8.533-8.533V222.147l17.92,35.84
				c1.707,3.413,4.267,5.12,7.68,5.12c1.707,0,2.56,0,3.413-1.707C492.28,259.693,493.987,254.573,492.28,250.307z M193.119,424.499
				l-31.933,48.033V376.6L193.119,424.499z M203.507,440.081l35.617,53.426h-71.135L203.507,440.081z M295.713,425.02
				l-32.126,47.784v-95.839L295.713,425.02z M246.52,473.453l-32.645-48.968l32.645-49.105V473.453z M306.092,440.546l35.407,52.961
				h-71.013L306.092,440.546z M316.513,425.046l32.407-48.203v96.678L316.513,425.046z M306.133,409.521l-35.13-52.548h70.459
				L306.133,409.521z M203.487,408.904l-34.62-51.93h69.144L203.487,408.904z M442.787,493.507h-76.8V348.44
				c0-5.12-3.413-8.533-8.533-8.533h-102.4h-102.4c-5.12,0-8.533,3.413-8.533,8.533v145.067h-76.8V188.628
				c0.112-0.371,0.197-0.743,0.253-1.115l49.241-97.632l138.24-73.387l138.24,73.387l49.493,98.133V493.507z"/>
          <path d="M374.52,246.04V135.107c0-5.12-3.413-8.533-8.533-8.533H144.12c-5.12,0-8.533,3.413-8.533,8.533V246.04h-16.213
				c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h24.747h34.133h85.333h59.733h42.667h24.747
				c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533H374.52z M152.653,143.64h204.8v102.4H331v-25.6
				c0-34.987-23.893-49.493-47.787-58.88c-1.707-0.853-4.267-0.853-5.973,0c-17.637,7.349-36.528,17.239-44.162,37.825l-9.598-3.692
				c-1.707-0.853-4.267-0.853-5.973,0l-11.093,4.267c-19.516,7.506-33.084,25.577-36.069,46.08h-17.691V143.64z M213.24,216.173
				l7.68-3.413l7.68,2.56c1.389,0.608,2.722,1.282,4.02,1.993c0.533,0.548,1.174,1.03,1.953,1.42
				c2.297,1.225,4.422,2.706,6.375,4.382c0.198,0.174,0.398,0.346,0.593,0.523c0.343,0.308,0.675,0.627,1.007,0.947
				c0.338,0.328,0.674,0.657,1,0.995c0.346,0.36,0.685,0.729,1.017,1.103c0.189,0.211,0.38,0.42,0.565,0.634
				c4.506,5.301,7.61,11.833,9.033,18.723H187.64C190.2,232.387,199.587,221.293,213.24,216.173z M271.267,246.04
				c-1.707-15.36-10.24-29.013-23.04-38.4c4.267-11.947,13.653-21.333,32.427-29.013c24.747,10.24,34.133,22.187,34.133,41.813v25.6
				H271.267z"/>
        </g>
      </g>
    </g>
  </svg>
)

const FarmerIcon: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={FarmerSvg} {...props} />
);

const FarmIcon: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={FarmSvg} {...props} />
)

const LandIcon: React.FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={LandSvg} {...props} />
)
const items: RestrictedMenuItem[] = [
  {
    label: 'กลุ่มเกษตรกร (Farmer)',
    key: 'farmer',
    icon: <FarmerIcon />,
  },
  {
    label: 'กลุ่มที่ดิน (Land)',
    key: 'land',
    icon: <LandIcon />,
  },
  {
    label: 'กลุ่มที่ฟาร์ม (Farm)',
    key: 'farm',
    icon: <FarmIcon />,
  },
  {
    label: 'กลุ่มรอบการเพาะปลูก (Crop)',
    key: 'crop',
    icon: <ExperimentOutlined />,
    envRestriction: 'production'
  },
  {
    label: "กลุ่มกิจกรรม (Operation)",
    key: 'operation',
    icon: <ProductOutlined />,
  },
  {
    label: 'กลุ่มสต๊อกปัจจัยการผลิต (Stock)',
    key: 'stockfactor',
    icon: <StockOutlined />,
  },
  {
    label: 'กลุ่มคาร์บอน (Carbon Footprint)',
    key: 'carbonfootprint',
    icon: <HeatMapOutlined />,
  },
  {
    label: 'กลุ่มภาพถ่าย (Images)',
    key: 'images',
    icon: <PictureOutlined />,
    envRestriction: 'production'
  },
  {
    label: 'กลุ่มวิสาหกิจชุมชน',
    key: 'community',
    icon: <TeamOutlined />,
    envRestriction: 'production'
  },
  {
    label: 'กลุ่มข่าวสาร (News)',
    key: 'news',
    icon: <FileTextOutlined />,
    envRestriction: 'production'
  },
  {
    label: 'กลุ่มล้ง (Merchant)',
    key: 'merchant',
    icon: <ShopOutlined />,
    envRestriction: 'production'
  },
  {
    label: 'กลุ่มราคา (Price)',
    key: 'price',
    icon: <DollarOutlined />,
    envRestriction: 'production'
  }
];

// Get the current environment from process.env
// Use a fallback of 'development' if the variable is not set
const CURRENT_ENV = process.env.REACT_APP_ENV || 'development';

// Filter the items based on the environment
const filteredItems = items.filter(item => {
  // If no restriction is set, the item is always included
  if (!item.envRestriction) {
    return true;
  }

  // Exclude the item if its restriction matches the current environment
  // e.g., if CURRENT_ENV is 'uat' and envRestriction is 'uat', it's excluded.
  return item.envRestriction !== CURRENT_ENV;
});

const MasterMenu: React.FC<{
  onchange: (key?: string) => void;
}> = ({ onchange }) => {
  const [current, setCurrent] = useState('farmer');

  const onClick: MenuProps['onClick'] = e => {
    setCurrent(e.key);
    onchange(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="vertical"
      items={items as MenuProps['items']}
      style={{ fontSize: '1rem' }}
    />
  );
};

export default MasterMenu;
